export interface GeoapifyAddressProperties {
  formatted?: string;
  address_line1?: string;
  address_line2?: string;
  housenumber?: string;
  street?: string;
  city?: string;
  state_code?: string;
  postcode?: string;
}

export interface GeoapifySuggestion {
  properties?: GeoapifyAddressProperties;
}

export function buildAddressLine1(properties?: GeoapifyAddressProperties): string {
  const parts = [properties?.housenumber, properties?.street].filter(Boolean);
  if (parts.length > 0) {
    return parts.join(' ');
  }

  return properties?.address_line1 ?? properties?.formatted ?? '';
}